// extracted by mini-css-extract-plugin
export var infoItem = "_r5-2";
export var title = "_r5-0";
export var value = "_r5-1";